import { Component, OnInit } from '@angular/core';
import { CheckoutService } from '../checkout.service';
import { SharedService } from '../../shared.service';
import { CartService } from '../../cart/cart.service';
import { ModalService } from '../../modal/modal.service';
import { SiteConfig } from 'app/interfaces/SiteConfig';
import { FormGroup } from '@angular/forms';
import { AppHttpService } from 'app/app-http.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  private _window: Window;

  public addressData = null;
  public confirmationIsValid = true;
  public orderErrorMessages: string[] = [];
  public orderErrorOrigin: string;
  public payment: string = null;
  public pension = false;
  public hasSepa: boolean = true;
  public env: string;
  public siteConfig: SiteConfig = this.sharedService.getSiteConfig();
  public showCartPage = this.siteConfig.showCartPage;
  public wbkz: string = this.checkoutService.getWbkz();
  public submitLoading = false;
  public hideCouponForm = false;
  public couponConfirmation: string | null = null;
  public showLimit: boolean = false;
  public maxMonthlyCosts: number = this.checkoutService.getMaxMonthlyCost();
  public isLoggedIn: boolean = false;
  public landingPageId: string = this.siteConfig.landingPageId;
  public savedPaymentMethod: string;

  constructor(
    private checkoutService: CheckoutService,
    private cartService: CartService,
    private sharedService: SharedService,
    private modalService: ModalService,
    private api: AppHttpService
  ) {
    this.addressData = this.checkoutService.getAddressData();
    this._window = window;
    this.pension =
      sharedService.getLotterySource() === 'pension' ? true : false;
    this.env = this.sharedService.getEnvironment();

    const formContainer = document.querySelector('.lp-form-container');
    const formHeading = document.querySelector('#lp-form-heading-count');

    if (!formContainer || !formHeading) return;

    formContainer['style'].display = 'none';
    formHeading['style'].display = 'none';
  }

  ngOnInit() {
    this.checkoutService.getMe().subscribe(
      (response) => {
        this.isLoggedIn = true;
        this.sharedService.setLoggedIn(true);

        if (response && response.person) {
          this.maxMonthlyCosts = response.person.maxMonthlyCosts;
          this.savedPaymentMethod = response.person.paymentMethod;
        }
      },
      (error) => {
        this.isLoggedIn = false;
        this.sharedService.setLoggedIn(false);
      }
    );

    this.checkoutService.confirmationUpdated.subscribe((coupon) => {
      this.confirmationIsValid = coupon;
    });

    /**
     * Hide the coupon field when wbkz value contains 'PA':
     * See GDE-327 for further information.
     *
     * In case of removing this feature also remove
     * condition from submit error case.
     */
    if (this.wbkz && this.wbkz.includes('PA')) {
      this.hideCouponForm = true;
    }

    if (this.showCartPage) {
      this.sharedService.pushToDataLayer(
        { step: 3 },
        this.cartService.getProducts()
      );
    } else {
      const landingPageId = this.sharedService.getSiteConfig().landingPageId;

      this.api.getPaymentMethods(landingPageId).subscribe((response) => {
        if (response['paymentMethods'].includes('ibanWithSepa')) {
          this.hasSepa = true;
        } else {
          this.hasSepa = false;
        }
      });
    }
  }

  openModal(type) {
    this.modalService.openModal(type);

    return false;
  }

  toggleLimit() {
    this.showLimit = !this.showLimit;

    return false;
  }

  onLimitFormChange(form: FormGroup) {
    form.valueChanges.subscribe((value) => {
      this.maxMonthlyCosts = value.limit;
      this.checkoutService.setConfirmValidation(form.valid);
    });
  }

  submitOrder() {
    this.confirmationIsValid = false;
    this.submitLoading = true;
    this.hideCouponForm = true;
    this.couponConfirmation = '';
    const orderData = this.checkoutService.getOrderData();

    orderData.maxMonthlyCosts = this.maxMonthlyCosts;

    this.checkoutService.orders(orderData).subscribe(
      (response) => {
        this.sharedService.setLocalStorage('orderResponse', response);

        this.sharedService.removeCookie('coupon');
        this.sharedService.removeCookie('coupon-set');
        this.sharedService.removeFromSessionStorage('couponData');

        if (this.wbkz && this.wbkz.includes('PA')) {
          this.sharedService.removeCookie('wbkz');
        }

        this.sharedService.clearOrderDataFromLs();

        const callBackUrl =
          orderData.paymentMethod === 'paypal' && response.paypalRedirectUrl
            ? response.paypalRedirectUrl
            : this.sharedService.getSiteConfig().callbackURL;
        this._window.location.href = callBackUrl;
        this.submitLoading = false;
      },
      (errorResponse) => {
        this.confirmationIsValid = true;
        this.orderErrorMessages = errorResponse.error.msgs;
        this.orderErrorOrigin = errorResponse.error.origin;
        this.submitLoading = false;
        this.couponConfirmation = null;
        this.cartService.setDiscount(0, '');

        if (this.wbkz && !this.wbkz.includes('PA')) {
          this.hideCouponForm = false;
        }
      }
    );
  }
}
